var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_vm._m(0),_c('h1',{staticClass:"title password-changed-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("default")],2),_vm._t("button")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-icon-container"},[_c('span',{staticClass:"material-symbols-outlined success-icon"},[_vm._v("\n        check_circle\n      ")])])
}]

export { render, staticRenderFns }